// @flow

export const SWITCH_TO_BLUESCAPE = 'band-redux/zoom/SWITCH_TO_BLUESCAPE';